export function displayAlert(message: string) {
  console.log('Alert: ' + message);
  alert(message);
}
